import { render, staticRenderFns } from "./catalog-filters.vue?vue&type=template&id=5c0f170b&scoped=true&"
import script from "./catalog-filters.vue?vue&type=script&lang=js&"
export * from "./catalog-filters.vue?vue&type=script&lang=js&"
import style0 from "./catalog-filters.vue?vue&type=style&index=0&id=5c0f170b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0f170b",
  null
  
)

export default component.exports